import { createRoot } from 'react-dom/client';

import './shared/styles/tailwind.css';

import { App } from './app/app.tsx';

createRoot(document.getElementById('root')!).render(<App />);
